import imgModuleSvg from '@elotech/arc/src/assets/img/modules/oxy-administrativo.svg';
import { Icon, useOnClickOutside } from '@elotech/components';
import classnames from 'classnames';
import React, { useRef } from 'react';

const Header = ({
  headerTitle,
  isLogged,
  hideUserInfo,
  ui,
  auth,
  sidebarToggle,
  offsidebarModuloToggle,
  offsidebarUsuarioToggle,
  offsidebarAcessibilidadeToggle,
  offsidebarLoginToggle,
  offsidebarUsuarioAndEntidadeToggle,
  offsidebarTurnOffAllFeatures,
  children,
  nomeModulo = 'Protocolo'
}) => {
  const headerRef = useRef(null);

  useOnClickOutside(headerRef, () => {
    const somethingIsOpen =
      ui.offsidebarModuloToggled ||
      ui.offsidebarUsuarioToggled ||
      ui.offsidebarAcessibilidadeToggled ||
      ui.offsidebarUsuarioEntidadeAtiva ||
      ui.offsidebarLoginToggled;

    if (somethingIsOpen) {
      offsidebarTurnOffAllFeatures();
    }
  });

  const classNameHeader = classnames({
    header: true,
    'sidebar-toggle': ui.sidebarToggled
  });

  const classNameUserOuAjustes = classnames({
    active: ui.offsidebarUsuarioToggled
  });

  const classesButton = classnames({
    'header-toggle-sidebar': true,
    'toggle-control': true,
    'sidebar-toggle': ui.sidebarToggled,
    'hidden-lg': true,
    'hidden-md': true
  });

  const classesHiddenForMobile = classnames({
    'hidden-sm': true,
    'hidden-md': true,
    'hidden-lg': true
  });

  const renderHeaderTitleContent = () => (
    <div className="content-title">
      {auth.getIn(['userInfo', 'entidade', 'brasao']) && (
        <figure className="brasao">
          <img
            id="headerBrasao"
            src={`data:image/png;base64, ${auth.getIn([
              'userInfo',
              'entidade',
              'brasao'
            ])}`}
            alt="Brasão"
          />
        </figure>
      )}

      <span onClick={offsidebarUsuarioAndEntidadeToggle}>{headerTitle}</span>
    </div>
  );

  const classNameLogin = classnames({
    active: ui.offsidebarLoginToggled
  });

  const classNameAcessibilidade = classnames({
    active: ui.offsidebarAcessibilidadeToggled
  });

  const classNameModulos = classnames({
    active: ui.offsidebarModuloToggled
  });

  return (
    <header
      ref={headerRef}
      className={`${classNameHeader} new flex`}
      style={{ overflow: 'visible' }}
    >
      <div className="header-content">
        <div className="logo">
          <img
            aria-hidden
            alt="Logo Oxy Administrativo"
            src={imgModuleSvg}
            className="module-color hidden-xs"
            style={{ width: '40px' }}
          />
          {nomeModulo}
        </div>

        <button
          className={classesButton}
          aria-label="Botão para expandir o menu"
          onClick={sidebarToggle}
        >
          <em className="fa fa-bars"></em>
        </button>

        <div className="header-title hidden-xs">
          {renderHeaderTitleContent()}
        </div>

        {!isLogged && (
          <ul className="header-features">
            <li
              className={classNameLogin}
              title="Login"
              onClick={offsidebarLoginToggle}
            >
              <Icon icon="user" />
              <small className="hidden-xs">Login</small>
            </li>
          </ul>
        )}

        {!hideUserInfo && isLogged && (
          <ul className="header-features">
            <li
              className={classNameAcessibilidade}
              title="Acessibilidade"
              onClick={offsidebarAcessibilidadeToggle}
            >
              <Icon icon="wheelchair" />
              <small className="hidden-xs">Acessibilidade</small>
            </li>

            <li
              title="Ajustes"
              className={classNameUserOuAjustes}
              onClick={offsidebarUsuarioToggle}
            >
              <Icon icon="tools" />
              <small className="hidden-xs">Ajustes</small>
            </li>

            <li
              title="Módulos"
              className={classNameModulos}
              onClick={offsidebarModuloToggle}
            >
              <Icon icon="th" />
              <small className="hidden-xs">Módulos</small>
            </li>
          </ul>
        )}
        {children}
      </div>
      <div className={`header-content-mobile ${classesHiddenForMobile}`}>
        <div className="header-title">{renderHeaderTitleContent()}</div>
      </div>
    </header>
  );
};

export default Header;
